export default __webpack_public_path__ + "static/media/red-map-dot.b465b8dc.svg";